import React from "react";

import logo from "../../media/green-right-small-logo_1.png";

export default function ReusableContact() {
  return (
    <div className="reusableContactContainer">
      <div className="logoContainer">
        <img src={logo} alt="Green Right Window Cleaning logo" />
      </div>
      <address className="reusableContact">
        <h3 className="reusableContactTitle">
          For GTA, Collingwood, Cottage Country:
        </h3>
        <p>
          Call Us At: <a href="tel:+4162365686">416-236-5686</a>
        </p>
        <p>
          Email us at:{" "}
          <a href="mailto:info@greenrightwindowcleaning.com">
            info@greenrightwindowcleaning.com
          </a>
        </p>
        <h3 className="reusableContactTitle">For Cambridge, Guelph, KW:</h3>
        <p>
          Call Us At: <a href="tel:+2263393998">226-339-3998</a>
        </p>
        <p>
          Email Us At:{" "}
          <a href="mailto:Greenright@greenrightwindowcleaning.com">
            Greenright@greenrightwindowcleaning.com
          </a>
        </p>
      </address>
    </div>
  );
}
